<div class="modal">
  <p>{{confirmationData?.body}}</p>
  <div class="popup-buttons">
    <app-shared-button-component
      [variant]="'tertiary'"
      [buttonName]="'BUTTONS.CANCEL' | translate"
      [caller]="closePopupCallback()">
    </app-shared-button-component>
    <app-shared-button-component
      [buttonName]="'BUTTONS.CONFIRM' | translate"
      [caller]="confirm()">
    </app-shared-button-component>
  </div>
</div>
